<template>
  <div v-if="isReady" id="app" class="application">
    <ab-header></ab-header>
    <main v-if="isAuthenticated">
      <router-view />
    </main>
    <main v-else>
      <ab-login-view />
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Login from '@/views/Login';

import Header from '@/components/Header';

export default {
  components: {
    'ab-login-view': Login,
    'ab-header': Header
  },
  meta: {
    title: 'Home',
    titleTemplate: `%s | +Yas/Nah- – Let's teach AI together`
  },
  data() {
    return {
      isReady: false
    };
  },
  computed: {
    ...mapState({
      isAuthenticated: s => s.identity.isAuthenticated
    })
  },
  async created() {
    await this.$store.dispatch('identity/initialize');
    this.isReady = true;
  }
};
</script>

<style lang="scss">
:root {
  // --theme-default: #607d8b;
  // --theme-default-light: rgba(0, 0, 0, 0.12);
  // --theme-default-dark: #455a64;

  --theme-primary: #fc6352;

  // --theme-primary-dark: #2e815b;

  --theme-secondary: #ffffff;

  --theme-highlight: rgba(0, 0, 0, 0.1);

  // #e80a89

  --theme-success: #28a745;
  --theme-error: #dc3545;
  --theme-background: #ffffff;
  --theme-surface: #ffffff;
  // --theme-surface: #424242;

  // --theme-on-default: #fff;
  --theme-on-primary: #fff;
  --theme-on-secondary: #000000;
  --theme-on-error: #fff;
  --theme-on-success: #fff;

  --theme-on-background: #000;
  // --theme-on-background-dark: #999999;
  --theme-on-surface: #000;
  // --theme-on-surface-dark: #999999;
}
</style>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  -ms-word-wrap: break-word;
  word-wrap: break-word;
  background-color: #fff;
  position: relative;
  font-size: 15px;
  color: #2d313d;
  font-family: 'Kanit';
  font-weight: 300;
}
button {
  background-color: transparent;
}
label {
  margin-bottom: 0 !important;
}
img {
  margin: 0;
  padding: 0;
  border: none;
  max-width: 100%;
  height: auto;
}
section img {
  max-width: 100%;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 10px 0;
  line-height: 1.4;
  letter-spacing: 1px;
  color: #2d313d;
}
p {
  margin: 0 0 15px;
  padding: 0;
  font-size: 110%;
  font-weight: 300;
  font-family: 'Roboto';
}
p,
ul li a {
  letter-spacing: 0px;
}
body a {
  text-decoration: none;
  color: #fc6352;
}
a:hover {
  text-decoration: none;
  color: #666;
}
a:focus,
a:hover {
  text-decoration: none !important;
}
ul,
ol {
  margin: 0 0 0 15px;
  padding: 0;
}

// :hover {
//   -webkit-transition-duration: 1s;
//   -moz-transition-duration: 1s;
//   -o-transition-duration: 1s;
//   transition-duration: 1s;
// }

hr {
  background-color: rgba(242, 242, 242, 0.75);
  margin: 1rem 0;
  padding: 0;
  border: 0px none;
  height: 2px;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}
</style>

<style lang="scss">
body {
  min-width: 320px;
}

.application {
  display: grid;
  grid-gap: 1rem;
  grid-template-rows: max-content minmax(0, 1fr);
  width: 100%;
  height: 100%;
}
.container {
  max-width: 1140px;
  margin: auto;
  padding: 0 0.5rem;
  box-sizing: border-box;
}

main {
  height: 100%;
}
</style>
